export default __webpack_public_path__ + "01d892ef774d818bf472a6090dbab76c.svg";